export default {
  FilesBtnFilesAdd: 'FilesBtnFilesAdd',
  FilesBtnFilesAddFileToEvidence: 'FilesBtnFilesAddFileToEvidence',
  FilesBtnFilesDelete: 'FilesBtnFilesDelete',
  FilesBtnFilesImportReport: 'FilesBtnFilesImportReport',
  FilesBtnFilesDocumentsProvided: 'FilesBtnFilesDocumentsProvided',
  FilesBtnFilesEdite: 'FilesBtnFilesEdite',
  FilesBtnFilesMergeFiles: 'FilesBtnFilesMergeFiles',
  FilesBtnFilesOcr: 'FilesBtnFilesOcr',
  FilesBtnFilesSplitFile: 'FilesBtnFilesSplitFile',

  FilesPageFilesFormAdd: 'FilesPageFilesFormAdd',
  FilesPageFilesFormEdit: 'FilesPageFilesFormEdit',
  FilesPageFilesList: 'FilesPageFilesList',
  FilesPageFilesImportReport: 'FilesPageFilesImportReport',

  FilesSectionFilesOcr: 'FilesSectionFilesOcr',

  FilesSectionFilesOcrNoLimit: 'FilesSectionFilesOcrNoLimit',
  FilesCanPerformOCR: 'FilesCanPerformOCR',
};

